




































































































import { Component, Vue } from "vue-property-decorator";
import RiskMap from "./RiskMap.vue";
import EventBus from "@/event-bus.ts";

import moment from "moment";
import { API_WS_URL } from "../http";
import { authUser } from "../auth/User";

@Component({
  components: {
    "risk-map": RiskMap
  },
  filters: {
    moment: function(timestamp: number) {
      return moment.unix(timestamp).format("DD/MM/YYYY HH:mm");
    }
  }
})
export default class EmergenciesView extends Vue {
  activeTab: string = "map";
  emergencyList: Array<any> = [];
  openedEmergencies: Array<any> = [];
  loading: boolean = false;
  notification_channel: any = null;

  beforeMount() {
    this.$http
      .get("/emma/admin/emergencies", { params: { limit: 10 } })
      .then(resp => {
        this.emergencyList = resp.data;
        EventBus.$emit("emergency-load-complete", resp.data);
      });
    EventBus.$on("new-emergency", (emergency: any) => {
      this.emergencyList.unshift(emergency);
    });
    EventBus.$on("display-on-map", (data: any) => {
      this.activeTab = "map";
    });

    this.notification_channel = new WebSocket(
      API_WS_URL + "?city=" + authUser.emmaCity
    );
    const self = this;
    this.notification_channel.onmessage = function(event: any) {
      const message = JSON.parse(event.data);
      if (message.type == "warning") {
        EventBus.$emit("new-warning", message);
      } else {
        const emergency = self.emergencyList.find(
          (em: any) => (em.id = message.emergency_id)
        );
        if (emergency) self.openEmergency(emergency, true);
        message.is_sent = false;
        self.$nextTick(() => EventBus.$emit("new-message", message, true));
      }
    };
  }

  imageType(title: string) {
    if (title.toUpperCase() == "FRANA")
      return require("../assets/landslide.png");
    else if (title.toUpperCase() == "COLATA DI FANGO")
      return require("../assets/avalanche.png");
    else return require("../assets/danger.png");
  }

  async loadMoreEmergencies() {
    let resp = null;
    try {
      this.loading = true;
      const last_emergency = this.emergencyList[this.emergencyList.length - 1];
      const last_id = last_emergency ? last_emergency["id"] : 0;
      resp = await this.$http.get("/emma/admin/emergencies", {
        params: { after: last_id, limit: 10 }
      });
      this.emergencyList.forEach(e => this.$set( e, 'showAdditionalData', false));
      this.emergencyList.push(...resp.data);
      EventBus.$emit("emergency-load-complete", resp.data);
    } catch (e) {
    } finally {
      if (resp && resp.data.length == 0) this.loading = true;
      else this.loading = false;
    }
  }

  openEmergency(emergency: any, notify: boolean) {
    EventBus.$emit("open-emergency", emergency, notify);
  }
  showOnMap(emergency: any) {
    if (emergency.coordinates && emergency.coordinates[0]) {
      EventBus.$emit("display-on-map", emergency);
    }
  }

  closeEmergency(emergency: any) {
    this.$swal({
      title: "Attenzione",
      text: `Risolvere l'emergenza #${emergency.id} ${emergency.name} ${moment.unix(emergency.timestamp).format("DD/MM/YYYY HH:mm")}`,
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "OK",
      cancelButtonText: "Annulla"
    }).then(result => {
      if (result.value) {
        this.$http
          .post(`/emma/admin/emergencies/${emergency.id}/close`)
          .then(response => {
            if (response.data.success) {
              this.emergencyList = this.emergencyList.filter(
                (value, index) => value.id != emergency.id
              );
              this.$swal("OK", `L'emergenza è stata risolta`, "success");
            }
          });
      }
    });
  }
}
